<template>
  <v-dialog
    v-model="orderStore.viewDialogModel"
    :persistent="orderStore.viewDialogLoading"
    max-width="650"
    class="elevation-0"
    scrollable
    overlay-opacity="0.6"
  >
    <v-card
      rounded="xl"
      flat
      :disabled="orderStore.viewDialogLoading"
      :class="{
        'scrollable-card': !isScroll,
        'scrollable-text-card': !isScroll && $vuetify.breakpoint.mdAndDown,
        'scrollable-not-card': !isScroll && arrivedState.bottom,
      }"
    >
      <v-card-title class="grey">
        <h4 class="text-body-1 text-sm-h6 font-weight-bold">Sipariş Detay</h4>

        <v-spacer />

        <v-btn
          v-if="$vuetify.breakpoint.smAndUp"
          rounded
          small
          depressed
          color="chip"
          class="text-capitalize"
          @click="orderStore.viewDialogClose"
        >
          <v-icon left>{{ icons.mdiClose }}</v-icon>
          Kapat
        </v-btn>
        <v-icon v-else small @click="orderStore.viewDialogClose">{{ icons.mdiClose }}</v-icon>
      </v-card-title>

      <v-divider />
      <v-card-text
        class="pa-0"
        ref="scrollableEl"
        :style="$vuetify.breakpoint.smAndUp ? 'height: 735px' : 'height: 100dvh'"
      >
        <v-list>
          <v-list-item class="px-3 px-md-6">
            <v-list-item-content>
              <v-list-item-subtitle>Cari Unvan</v-list-item-subtitle>
              <v-list-item-title v-if="!$vuetify.breakpoint.smAndUp">{{
                customerName(
                  orderStore.viewDialogData.customer_name,
                  orderStore.viewDialogData.adsoyad
                )
              }}</v-list-item-title>
            </v-list-item-content>
            <v-list-item-action v-if="$vuetify.breakpoint.smAndUp">
              {{
                customerName(
                  orderStore.viewDialogData.customer_name,
                  orderStore.viewDialogData.adsoyad
                )
              }}
            </v-list-item-action>
          </v-list-item>
          <v-divider />

          <v-list-item
            class="px-3 px-md-6"
            v-if="orderStore.viewDialogData.order_data.poNumber != null"
          >
            <v-list-item-content>
              <v-list-item-subtitle>SAS Numarası</v-list-item-subtitle>
              <v-list-item-title v-if="!$vuetify.breakpoint.smAndUp">{{
                orderStore.viewDialogData.order_data.poNumber
              }}</v-list-item-title>
            </v-list-item-content>
            <v-list-item-action v-if="$vuetify.breakpoint.smAndUp">
              <v-chip label color="grey" class="d-flex justify-center text-caption">
                <span
                  class="text-caption text-xl-subtitle-2"
                  style="letter-spacing: 0.5px; color: azure"
                  >{{ orderStore.viewDialogData.order_data.poNumber }}</span
                >
              </v-chip>
            </v-list-item-action>
          </v-list-item>
          <v-divider v-if="orderStore.viewDialogData.order_data.poNumber != null" />

          <v-list-item
            class="px-3 px-md-6"
            v-if="orderStore.viewDialogData.order_data.delirveryDate != null"
          >
            <v-list-item-content>
              <v-list-item-subtitle>İstenilen Teslimat Tarihi</v-list-item-subtitle>
              <v-list-item-title v-if="!$vuetify.breakpoint.smAndUp">{{
                orderStore.viewDialogData.order_data.delirveryDate | moment("DD.MM.YYYY")
              }}</v-list-item-title>
            </v-list-item-content>
            <v-list-item-action v-if="$vuetify.breakpoint.smAndUp">
              <v-chip color="grey" class="d-flex justify-center" label>
                <div
                  class="d-flex align-center"
                  style="
                    text-align: center;
                    font-size: 11px !important;
                    letter-spacing: 0.5px;
                    color: azure;
                  "
                >
                  <div class="mr-1">
                    {{
                      orderStore.viewDialogData.order_data.delirveryDate
                        | moment("DD MMMM YYYY, dddd")
                    }}
                  </div>
                  <v-icon color="" small class="ml-2">
                    {{ icons.mdiCalendar }}
                  </v-icon>
                </div>
              </v-chip>
            </v-list-item-action>
          </v-list-item>
          <v-divider v-if="orderStore.viewDialogData.order_data.delirveryDate != null" />

          <v-list-item class="px-3 px-md-6">
            <v-list-item-content>
              <v-list-item-subtitle>Sipariş Numarası</v-list-item-subtitle>
              <v-list-item-title v-if="!$vuetify.breakpoint.smAndUp">{{
                orderStore.viewDialogData.id
              }}</v-list-item-title>
            </v-list-item-content>
            <v-list-item-action v-if="$vuetify.breakpoint.smAndUp">
              <v-chip label color="grey" class="d-flex justify-center text-caption">
                <span
                  class="text-caption text-xl-subtitle-2"
                  style="letter-spacing: 0.5px; color: azure"
                  >{{ orderStore.viewDialogData.id }}</span
                >
              </v-chip>
            </v-list-item-action>
          </v-list-item>
          <v-divider />

          <v-list-item class="px-3 px-md-6">
            <v-list-item-content>
              <v-list-item-subtitle>Sipariş Tarihi</v-list-item-subtitle>
              <v-list-item-title v-if="!$vuetify.breakpoint.smAndUp">{{
                orderStore.viewDialogData.create_datetime | moment("DD.MM.YYYY - HH:mm")
              }}</v-list-item-title>
            </v-list-item-content>
            <v-list-item-action v-if="$vuetify.breakpoint.smAndUp">
              <v-chip color="grey" class="d-flex justify-center" label>
                <div
                  class="d-flex align-center"
                  style="
                    text-align: center;
                    font-size: 11px !important;
                    letter-spacing: 0.5px;
                    color: azure;
                  "
                >
                  <div class="mr-1">
                    {{ orderStore.viewDialogData.create_datetime | moment("DD.MM.YYYY ") }}
                  </div>

                  <span> - {{ orderStore.viewDialogData.create_datetime | moment("HH:mm") }}</span>
                  <v-icon color="" small class="ml-2">
                    {{ icons.mdiCalendarClock }}
                  </v-icon>
                </div>
              </v-chip>
            </v-list-item-action>
          </v-list-item>
        </v-list>
        <v-container class="px-6">
          <v-row>
            <v-col cols="12">
              <v-card
                flat
                outlined
                rounded="xl"
                style="height: 100%"
                :class="`type-${orderStore.viewDialogData.manager_appr_color}`"
              >
                <v-card-title>
                  Sipariş
                  <v-spacer />
                  <v-chip
                    :color="orderStore.viewDialogData.manager_appr_color"
                    class="d-flex justify-center text-caption"
                  >
                    <span
                      class="text-caption text-xl-subtitle-2"
                      style="letter-spacing: 0.5px; color: azure"
                      >{{ orderStore.viewDialogData.manager_appr_desc }}</span
                    >
                  </v-chip>
                </v-card-title>
                <v-card-subtitle v-if="orderStore.viewDialogData.manager_appr_date">
                  {{
                    orderStore.viewDialogData.manager_appr_date | moment("DD MMMM YYYY - HH:mm")
                  }}</v-card-subtitle
                >

                <v-card-text class="white--text" v-if="orderStore.viewDialogData.manager_notes">
                  <div class="text-overline">İptal Açıklaması</div>
                  <v-divider class="my-1" />
                  <div class="mb-3">{{ orderStore.viewDialogData.manager_notes }}</div>
                </v-card-text>

                <v-card-text
                  class="white--text"
                  v-if="orderStore.viewDialogData.order_data.buyer_note"
                >
                  <div class="text-overline">Sipariş Notu</div>
                  <v-divider class="my-1" />
                  <div>{{ orderStore.viewDialogData.order_data.buyer_note }}</div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
          <v-row v-if="userData.role === 'COMMAN'">
            <v-col cols="12" md="6">
              <v-card
                flat
                outlined
                rounded="xl"
                style="height: 100%"
                :class="`type-${orderStore.viewDialogData.delivery_appr_color}`"
              >
                <v-card-title>
                  Sevkiyat
                  <v-spacer />
                  <v-chip
                    :color="orderStore.viewDialogData.delivery_appr_color"
                    class="d-flex justify-center text-caption"
                  >
                    <span
                      class="text-caption text-xl-subtitle-2"
                      style="letter-spacing: 0.5px; color: azure"
                      >{{ orderStore.viewDialogData.delivery_appr_desc }}</span
                    >
                  </v-chip>
                </v-card-title>
                <v-card-subtitle v-if="orderStore.viewDialogData.delivery_appr_date">
                  {{
                    orderStore.viewDialogData.delivery_appr_date | moment("DD MMMM YYYY - HH:mm")
                  }}</v-card-subtitle
                >
                <v-card-text class="white--text" v-if="orderStore.viewDialogData.del_notes">
                  {{ orderStore.viewDialogData.del_notes }}
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12" md="6">
              <v-card
                flat
                outlined
                rounded="xl"
                style="height: 100%"
                :class="`type-${orderStore.viewDialogData.prod_appr_color}`"
              >
                <v-card-title>
                  Üretim
                  <v-spacer />
                  <v-chip
                    :color="orderStore.viewDialogData.prod_appr_color"
                    class="d-flex justify-center text-caption"
                  >
                    <span
                      class="text-caption text-xl-subtitle-2"
                      style="letter-spacing: 0.5px; color: azure"
                      >{{ orderStore.viewDialogData.prod_appr_desc }}</span
                    >
                  </v-chip>
                </v-card-title>
                <v-card-subtitle v-if="orderStore.viewDialogData.prod_appr_date">
                  {{
                    orderStore.viewDialogData.prod_appr_date | moment("DD MMMM YYYY - HH:mm")
                  }}</v-card-subtitle
                >
                <v-card-text class="white--text" v-if="orderStore.viewDialogData.prod_notes">
                  {{ orderStore.viewDialogData.prod_notes }}
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-card flat rounded="xl" outlined>
                <v-card-title class="pt-9">Sipariş Edilen Ürünler</v-card-title>
                <v-list nav class="pt-0">
                  <template v-for="(item, index) in orderStore.viewDialogData.products">
                    <v-list-item
                      class="px-3 px-md-6 py-0 py-md-2"
                      three-line
                      :key="`item-${index}`"
                    >
                      <v-list-item-avatar
                        tile
                        :height="$vuetify.breakpoint.smAndUp ? 75 : 50"
                        :width="$vuetify.breakpoint.smAndUp ? 75 : 50"
                        color="white"
                        class="rounded-lg"
                      >
                        <v-avatar tile :height="60" :width="60">
                          <v-img
                            v-if="item.resim"
                            :src="$baseUrlAPI+ '' + item.resim"
                            class="rounded-lg"
                          />
                          <v-icon v-else size="30" color="primary">
                            {{ icons.mdiCameraOff }}</v-icon
                          >
                        </v-avatar>
                      </v-list-item-avatar>

                      <v-list-item-content>
                        <v-list-item-title>
                          <div class="text-caption mb-1">
                            <v-chip
                              label
                              :small="$vuetify.breakpoint.smAndUp"
                              :x-small="!$vuetify.breakpoint.smAndUp"
                              color="secondary"
                              style="font-size: 10px"
                              >{{ item.material }}</v-chip
                            >
                          </div>
                          <div class="text-caption text-sm-subtitle-2 white--text">
                            {{ item.stext }}
                          </div>
                          <div class="text-caption" v-if="$vuetify.breakpoint.smAndUp"></div>
                          <div v-else class="text-caption">
                            <span>
                              {{ Number(item.qty) }}
                              <span v-if="item.birim">
                                {{
                                  $store.state.tanimlar.birim.find((el) => el.value === item.birim)
                                    .text
                                }}
                              </span>
                              <span v-else>Tanımsız</span>
                            </span>
                          </div>
                        </v-list-item-title>
                      </v-list-item-content>

                      <v-list-item-action v-if="$vuetify.breakpoint.smAndUp">
                        <span>
                          {{ Number(item.qty) }}

                          <span v-if="item.birim">
                            {{
                              $store.state.tanimlar.birim.find((el) => el.value === item.birim).text
                            }}
                          </span>
                        </span>
                      </v-list-item-action>
                    </v-list-item>

                    <v-divider
                      :key="`divider-${index}`"
                      v-if="orderStore.viewDialogData.products.length > index + 1"
                    />
                  </template>
                </v-list>
              </v-card>
            </v-col>
          </v-row>
        </v-container>

        <div
          class="text-center pt-1"
          v-if="
            userData.role === 'SUPER' ||
            (userData.role === 'COMMAN' && orderStore.viewDialogData.manager_appr_state != '2')
          "
        >
          <v-btn plain @click="saleCancel" class="text-capitalize">
            <v-icon size="24" left>
              {{ icons.mdiDeleteOutline }}
            </v-icon>
            Siparişi İptal Et</v-btn
          >
        </div>
      </v-card-text>
      <v-card-actions></v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { ref, onMounted } from "vue-demi";

// Pinia
import { useOrderStore } from "@/stores/order";

// Utils
import { useScroll, useResizeObserver } from "@vueuse/core";

// Icons
import {
  mdiClose,
  mdiTrashCan,
  mdiCalendarClock,
  mdiCalendar,
  mdiCameraOff,
  mdiDeleteOutline,
} from "@mdi/js";

export default {
  setup(props, { emit }) {
    // Pinia
    const orderStore = useOrderStore();

    const deleteItem = () => {
      emit("deleteItem");
    };
    const saleCancel = () => {
      emit("saleCancel", { id: orderStore.viewDialogData.id });
    };

    const scrollableEl = ref(null);
    const userData = JSON.parse(localStorage.getItem("userData"));
    // Kaydırma çubuğu
    const { arrivedState } = useScroll(scrollableEl);
    const isScroll = ref(false);
    onMounted(() => {
      isScroll.value = scrollableEl.value?.scrollHeight === scrollableEl.value?.offsetHeight;
    });

    // Ekran boyutu algılama
    useResizeObserver(scrollableEl, (entries) => {
      isScroll.value = scrollableEl.value?.scrollHeight === scrollableEl?.value.offsetHeight;
    });

    const customerName = (name, user) => {
      let result;
      result = name.split(" / ");
      if (result.length > 0) {
        result = result[0] + " | " + user.toUpperCase();
      } else {
        result = result[0];
      }
      return result;
    };

    return {
      customerName,
      userData,
      deleteItem,
      saleCancel,
      orderStore,
      scrollableEl,
      isScroll,
      arrivedState,
      // icons
      icons: {
        mdiClose,
        mdiTrashCan,
        mdiCalendarClock,
        mdiCalendar,
        mdiCameraOff,
        mdiDeleteOutline,
      },
    };
  },
};
</script>
<style lang="scss">
.v-card {
  &.type-warning {
    background: #ffb30010 !important;
    border-color: #ffb400 !important;
    .v-card__title {
      color: #ffb400 !important;
    }
  }
  &.type-success {
    background: #41990010 !important;
    border-color: #419900 !important;
    .v-card__title {
      color: #419900 !important;
    }
  }
  &.type-error {
    background: #ff4c5110 !important;
    border-color: #ff4c51 !important;
    .v-card__title {
      color: #ff4c51 !important;
    }
  }
}
</style>
